class VrmModal {
  constructor(container) {
    this.container = container;

    this.overlay = container;
    this.modal = container.querySelector('.vrm-modal-box');

    this.image = container.querySelector('#vrm-image');
    this.notFoundUrl = this.image.src
    this.model = container.querySelector('#vrm-model');

    this.close = container.querySelector('#vrm-modal-close');
    this.yes = container.querySelector('#vrm-yes');
    this.no = container.querySelector('#vrm-no');

    this.yesView = container.querySelector('.vrm-modal__yes');
    this.noView = container.querySelector('.vrm-modal__no');

    this.vehicleDetails = {};
    this.redirectUrl = null

    this.bindEvents();
  }

  bindEvents() {
    this.close.addEventListener('click', () => this.reset());

    this.no.addEventListener('click', () => {
      this.yesView.classList.add('hidden');
      this.noView.classList.remove('hidden');
      this.modal.classList.add('vrm-modal-box--full');
    });

    this.yes.addEventListener('click', () => {
      if (
        this.redirectUrl
      ) {
        window.location = this.redirectUrl;
      }
    });

    document.addEventListener('keyup', (e) => {
      if (e.key === 'Escape') {
        this.reset();
      }
    });

    document.addEventListener('platesInput', (event) => {
      if(event.detail.plate) {
        this.lookupVehicle(event.detail.plate);
      }
    });
  }

  reset() {
    this.overlay.classList.remove('visible');
    this.modal.classList.remove('vrm-modal-box--full');

    this.yesView.classList.remove('hidden');
    this.noView.classList.add('hidden');

    this.yes.disabled = false;
  }

  async lookupVehicle(plate) {
    this.vehicleDetails = {};

    this.yes.disabled = true;

    try {
      const { countryCode } = window.ShopContext
      
      try {
        const vehicleResponse = await fetch(
          `https://api.wiperz.co.uk/car/by-plate/${countryCode || 'IE'}/${plate}`
        );
        

        const vehicle = await vehicleResponse.json();

        const imageId = vehicle.imageURL800 ? vehicle.imageURL800.replace(
          'https://webservice.tecalliance.services/digital-assets-proxy/tecdoc/',
          ''
        ) : '';

        this.vehicleDetails = {
          imageId,
          plate,
          ...vehicle
        };

        this.redirectUrl = vehicle.url

        if(imageId) {
          this.image.src =
            `https://webservice.tecalliance.services/digital-assets-proxy/tecdoc/${imageId}`;
        } else {
          this.image.src = this.notFoundUrl
            // '/cdn/shop/t/4/assets/wiperz-no-image-available.webp?v=56458218240714645581788084726'
        }

        this.model.textContent = `${vehicle.make} ${vehicle.model}`;

        this.overlay.classList.add('visible');

        this.yes.disabled = false;
      } catch(e){
        this.overlay.classList.add('visible');
        this.yesView.classList.add('hidden');
        this.noView.classList.remove('hidden');
      }
    } catch (error) {
      console.error(error);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const overlay = document.querySelector('#vrm-overlay');

  if (overlay) {
    new VrmModal(overlay);
  }
});